export { default as BottomTabIcon } from "./BottomTabIcon";
export { default as BottomTabLabel } from "./BottomTabLabel";
